import React, { useCallback, useState } from 'react';
import { useTooltip } from 'hooks/useTooltip';
import { RiChatDownloadFill } from 'react-icons/ri';
import { useSelector } from 'react-redux';
import ServiceCRUDChatTS from 'services/ServiceCRUDCHATTS';
import { useSocketConversationChatTs } from 'hooks/useSocketConversationChatTs';
import { toast } from 'react-toastify';
import debounce from 'lodash/debounce';

const pullChatService = new ServiceCRUDChatTS('/pull-chat');

/**
 * Renderiza o botão e o modal de resgate de conversas na tela de atendimento (Puxar conversas quando a fila não distribui)
 */
export function PullChatButton() {
  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const { socketChatTS } = useSocketConversationChatTs();
  const [isLoading, setIsLoading] = useState(false);

  const { withTooltip } = useTooltip();

  const getNewConversations = useCallback(async () => {
    setIsLoading(true);
    try {
      toast.info('Resgatando conversas...', {
        autoClose: 1500,
        closeOnClick: true
      });

      const res = await pullChatService.post('', {
        agentLogin: localStorage.getItem('login'),
        idSocketAgent: socketChatTS?.id
      });

      if (!(res?.status === 200)) {
        toast.error(`Não foi possível resgatar conversas em espera`, {
          autoClose: 3000,
          closeOnClick: true
        });
      }
    } finally {
      setIsLoading(false);
    }
  }, [socketChatTS?.id]);

  const debouncedGetNewConversations = useCallback(
    debounce(getNewConversations, 1000, { leading: true, trailing: false }),
    [getNewConversations]
  );

  return withTooltip(
    'Resgatar novas conversas',
    <RiChatDownloadFill
      size={20}
      style={{
        background: 'none',
        border: 'none',
        color: systemConfiguration.primary_color,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: isLoading ? 'wait' : 'pointer',
        opacity: isLoading ? 0.6 : 1,
        transition: 'opacity 0.2s ease-in-out',
        transform: isLoading ? 'scale(0.95)' : 'scale(1)'
      }}
      onClick={debouncedGetNewConversations}
    />
  );
}
